export default __webpack_public_path__ + "static/media/Gilroy-ExtraBold.0094146a.woff";